import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IbGenericFooterModule } from '../../../shared/components/ib-generic-footer/ib-generic-footer.module';
import { SharedModule } from '../../../shared/shared.module';
import { IbDisruptedSeatOptionOneComponent } from './ib-disrupted-seat-option-1/ib-disrupted-seat-option-one.component';
import { IbDisruptedSeatOptionTwoComponent } from './ib-disrupted-seat-option-2/ib-disrupted-seat-option-two.component';
import { IbDisruptedSeatOptionThreeComponent } from './ib-disrupted-seat-option-3/ib-disrupted-seat-option-three.component';
import { IbDisruptedSeatsComponent } from './ib-disrupted-seats.component';
import { IbDisruptedSeatsRefundModalComponent } from './ib-disrupted-seats-refund-modal/ib-disrupted-seats-refund-modal.component';
import { CustomCurrencyPipe } from '../../../shared/pipes/CustomCurrency.pipe';



@NgModule({
    declarations: [
        IbDisruptedSeatsComponent,
        IbDisruptedSeatOptionOneComponent,
        IbDisruptedSeatOptionTwoComponent,
        IbDisruptedSeatOptionThreeComponent,
        IbDisruptedSeatsRefundModalComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        IbGenericFooterModule
    ],
    exports: [
        IbDisruptedSeatsComponent
    ],
    providers: []

})
export class IbDisruptedSeatsModule { }
